import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HeadingText } from '@paypalcorp/pp-react';
import { isExternalFlow } from '../utility/externalIntegrationUtils';

class ConfirmationAmount extends Component {
  render() {
    return (
      <HeadingText
        size={isExternalFlow() ? 'lg' : 'sm'}
        className="text-center"
        style={{ margin: '24px auto' }}
      >
        {this.props.message}
      </HeadingText>
    );
  }
}
export default ConfirmationAmount;

ConfirmationAmount.propTypes = {
  message: PropTypes.object,
};
